var _effectorFileName = "/builds/gmini/front-ui-kit/src/Maintenance/Maintenance.tsx";
import React from 'react';
import { Button } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '../Typography';
import { Box } from '../Box';
import gearsIcon from './gears.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Maintenance = () => {
  const classes = useStyles();
  const onClick = React.useCallback(() => {
    window.location.reload();
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: classes.root,
    children: /*#__PURE__*/_jsxs("div", {
      className: classes.content,
      children: [/*#__PURE__*/_jsx("div", {
        className: classes.imageWrap,
        children: /*#__PURE__*/_jsx("img", {
          src: gearsIcon,
          className: classes.image
        })
      }), /*#__PURE__*/_jsx(Box, {
        mb: 2,
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          children: "\u041D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u0435\u0434\u0443\u0442\u0441\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u044B"
        })
      }), /*#__PURE__*/_jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/_jsx(Typography, {
          children: "\u042D\u0442\u043E \u043D\u0435 \u0437\u0430\u0439\u043C\u0451\u0442 \u043C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441 \u043F\u043E\u0437\u0436\u0435."
        })
      }), /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        color: "primary",
        onClick: onClick,
        children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
      })]
    })
  });
};
const useStyles = makeStyles(() => createStyles({
  root: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    marginTop: '-100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  imageWrap: {
    marginBottom: '20px'
  },
  image: {
    width: '150px'
  }
}));